import React, { createContext, useContext } from 'react';
import { User } from '../utils/types';

interface AuthContextType {
  currentUser: User | null;
  setCurrentUser: (user: User | null) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export const AuthProvider: React.FC<{ children: React.ReactNode; value: AuthContextType }> = ({
  children,
  value
}) => {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
